<script lang="ts">
    import ShareIcon from "./ShareIcon.svelte";
    import { _ } from "svelte-i18n";

    export let title: boolean = true;
</script>

{#if title}
<h3><ShareIcon class="d-inline me-2" /><strong>{$_("home.how.share.share")}</strong></h3>
{:else}
    <p class="mb-0">
        <strong>{$_("home.how.share.title")}</strong></p>
{/if}
<p>
    {$_("home.how.share.content")}
</p>